/* TODO- I dont like the way this is done, Abhi- please rewrite to a better way */
CustomTC.define('modules/logger',['modules/config'], function(config) {
    return {
        bufferedLogs: [],
        bufferedInfos: [],
        bufferedWarnings: [],
        bufferedErrors: [],
        bufferedDebugs: [],
        bufferedTraces: [],
        specialLogStyle: 'background: #ff9933; color: #000',
        logs: false,
        maxBuffer: 10,
        // set Logs
        setLogs: function(logs) {
            this.logs = logs;
        },
        init: function() {
            var _this = this;
            var noopLog =
                function() {
                    if (_this.logs === true) {
                        if (window.console === undefined) {

                        } else {
                            if (typeof arguments[0] !== 'undefined') {
                                var args = Array.prototype.slice.call(arguments);
                                if (typeof args[0] === 'string') {
                                    var label = 'TouchCast Player LOG: Version: ' + config.version + ' - ' + Date() + ' - ' + args[0];
                                    args.shift();
                                    args.unshift(label);
                                } else {
                                    args.unshift('TouchCast Player LOG: Version: ' + config.version + ' - ' + Date() + ' - ');
                                }
                                Function.prototype.apply.call(console.log, console, args);
                            }
                        }

                    } else {
                        if (typeof arguments[0] !== 'undefined') {
                            var args = Array.prototype.slice.call(arguments);
                            if (_this.bufferedLogs.length >= _this.maxBuffer) {
                                _this.bufferedLogs = [];
                            }
                            this.bufferedLogs.push(args);
                        }
                    }

                };
            var noopWarn =
                function() {
                    if (_this.logs === true) {
                        if (window.console === undefined) {

                        } else {
                            if (typeof arguments[0] !== 'undefined') {
                                var args = Array.prototype.slice.call(arguments);
                                args.unshift('TouchCast Player WARNING: Version: ' + config.version + ' - ' + Date() + ' - ');
                                Function.prototype.apply.call(console.warn, console, args);
                            }
                        }

                    } else {
                        if (typeof arguments[0] !== 'undefined') {
                            var args = Array.prototype.slice.call(arguments);
                            if (_this.bufferedWarnings.length >= _this.maxBuffer) {
                                _this.bufferedWarnings = [];
                            }
                            this.bufferedWarnings.push(args);
                        }
                    }

                };
            var noopError =
                function() {
                    if (_this.logs === true) {
                        if (window.console === undefined) {

                        } else {
                            if (typeof arguments[0] !== 'undefined') {
                                var args = Array.prototype.slice.call(arguments);
                                args.unshift('TouchCast Player ERROR: Version: ' + config.version + ' - ' + Date() + ' - ');
                                Function.prototype.apply.call(console.error, console, args);
                            }
                        }

                    } else {
                        if (typeof arguments[0] !== 'undefined') {
                            var args = Array.prototype.slice.call(arguments);
                            if (_this.bufferedErrors.length >= _this.maxBuffer) {
                                _this.bufferedErrors = [];
                            }
                            this.bufferedErrors.push(args);
                        }
                    }

                };
            var noopDebug =
                function() {
                    if (_this.logs === true) {
                        if (window.console === undefined) {

                        } else {
                            if (typeof arguments[0] !== 'undefined') {
                                var args = Array.prototype.slice.call(arguments);
                                args.unshift('TouchCast Player DEBUG: Version: ' + config.version + ' - ' + Date() + ' - ');
                                Function.prototype.apply.call(console.debug, console, args);
                            }
                        }

                    } else {
                        if (typeof arguments[0] !== 'undefined') {
                            var args = Array.prototype.slice.call(arguments);
                            if (_this.bufferedDebugs.length >= _this.maxBuffer) {
                                _this.bufferedDebugs = [];
                            }
                            this.bufferedDebugs.push(args);
                        }
                    }

                };
            var noopInfo =
                function() {
                    if (_this.logs === true) {
                        if (window.console === undefined) {

                        } else {
                            if (typeof arguments[0] !== 'undefined') {
                                var args = Array.prototype.slice.call(arguments);
                                args.unshift('TouchCast Player INFO: Version: ' + config.version + ' - ' + Date() + ' - ');
                                Function.prototype.apply.call(console.info, console, args);
                            }
                        }

                    } else {
                        if (typeof arguments[0] !== 'undefined') {
                            var args = Array.prototype.slice.call(arguments);
                            if (_this.bufferedInfos.length >= _this.maxBuffer) {
                                _this.bufferedInfos = [];
                            }
                            this.bufferedInfos.push(args);
                        }
                    }

                };
            var noopTrace =
                function() {
                    if (_this.logs === true) {
                        if (window.console === undefined) {

                        } else {
                            if (typeof arguments[0] !== 'undefined') {
                                var args = Array.prototype.slice.call(arguments);
                                args.unshift('TouchCast Player TRACE: Version: ' + config.version + ' - ' + Date() + ' - ');
                                Function.prototype.apply.call(console.trace, console, args);
                            }
                        }

                    } else {
                        if (typeof arguments[0] !== 'undefined') {
                            var args = Array.prototype.slice.call(arguments);
                            if (_this.bufferedTraces.length >= _this.maxBuffer) {
                                _this.bufferedTraces = [];
                            }
                            this.bufferedTraces.push(args);
                        }
                    }

                };

            var log;
            if (this.logs) {
                this.log = (window.console === undefined) ? noop : function() {
                    var args = Array.prototype.slice.call(arguments);
                    if (typeof args[0] === 'string') {
                        var label = 'TouchCast Player LOG: Version: ' + config.version + ' - ' + Date() + ' - ' + args[0];
                        args.shift();
                        args.unshift(label);
                    } else {
                        args.unshift('TouchCast Player LOG: Version: ' + config.version + ' - ' + Date() + ' - ');
                    }
                    Function.prototype.apply.call(console.log, console, args);
                };
                this.error = (window.console === undefined) ? noop : (Function.prototype.bind !== undefined) ? Function.prototype.bind.call(console.error, console, 'TouchCast Player ERROR: Version: ' + config.version + ' - ' + Date() + ' - ') : function() {
                    var args = Array.prototype.slice.call(arguments);
                    args.unshift('TouchCast Player ERROR: Version: ' + config.version + ' - ' + Date() + ' - ');
                    Function.prototype.apply.call(console.error, console, args);
                };
                this.warn = (window.console === undefined) ? noop : (Function.prototype.bind !== undefined) ? Function.prototype.bind.call(console.warn, console, 'TouchCast Player WARNING: Version: ' + config.version + ' - ' + Date() + ' - ') : function() {
                    var args = Array.prototype.slice.call(arguments);
                    args.unshift('TouchCast Player WARNING: Version: ' + config.version + ' - ' + Date() + ' - ');
                    Function.prototype.apply.call(console.warn, console, args);
                };
                this.debug = (window.console === undefined) ? noop : (Function.prototype.bind !== undefined) ? Function.prototype.bind.call(console.debug, console, 'TouchCast Player DEBUG: Version: ' + config.version + ' - ' + Date() + ' - ') : function() {
                    var args = Array.prototype.slice.call(arguments);
                    args.unshift('TouchCast Player DEBUG: Version: ' + config.version + ' - ' + Date() + ' - ');
                    Function.prototype.apply.call(console.debug, console, args);
                };
                this.info = (window.console === undefined) ? noop : (Function.prototype.bind !== undefined) ? Function.prototype.bind.call(console.info, console, 'TouchCast Player INFO: Version: ' + config.version + ' - ' + Date() + ' - ') : function() {
                    var args = Array.prototype.slice.call(arguments);
                    args.unshift('TouchCast Player INFO: Version: ' + config.version + ' - ' + Date() + ' - ');
                    Function.prototype.apply.call(console.info, console, args);
                };
                this.trace = (window.console === undefined) ? noop : (Function.prototype.bind !== undefined) ? Function.prototype.bind.call(console.trace, console, 'TouchCast Player TRACE: Version: ' + config.version + ' - ' + Date() + ' - ') : function() {
                    var args = Array.prototype.slice.call(arguments);
                    args.unshift('TouchCast Player TRACE: Version: ' + config.version + ' - ' + Date() + ' - ');
                    Function.prototype.apply.call(console.trace, console, args);
                };
                if (this.bufferedLogs.length > 0) {
                    for (i = 0; i < this.bufferedLogs.length; i++) {
                        if (typeof this.bufferedLogs[i][1] !== 'undefined') {
                            this.log('[Stored Log] ' + this.bufferedLogs[i][0], this.bufferedLogs[i][1])
                        } else {
                            if (this.bufferedLogs[i][0]) {
                                this.log('[Stored Log] ' + this.bufferedLogs[i][0])
                            }

                        }
                        if (i === this.bufferedLogs.length - 1) {
                            this.bufferedLogs = [];
                        }
                    }
                }
                if (this.bufferedErrors.length > 0) {
                    for (i = 0; i < this.bufferedErrors.length; i++) {

                        if (typeof this.bufferedErrors[i][1] !== 'undefined') {
                            this.error('[Stored Error] ' + this.bufferedErrors[i][0], this.bufferedErrors[i][1])
                        } else {
                            if (this.bufferedErrors[i][0]) {
                                this.error('[Stored Error] ' + this.bufferedErrors[i][0])
                            }

                        }
                        if (i === this.bufferedErrors.length - 1) {
                            this.bufferedErrors = [];
                        }
                    }
                }
                if (this.bufferedWarnings.length > 0) {
                    for (i = 0; i < this.bufferedWarnings.length; i++) {
                        if (typeof this.bufferedWarnings[i][1] !== 'undefined') {
                            this.warn('[Stored Warning] ' + this.bufferedWarnings[i][0], this.bufferedWarnings[i][1])
                        } else {
                            if (this.bufferedWarnings[i][0]) {
                                this.warn('[Stored Warning] ' + this.bufferedWarnings[i][0])
                            }

                        }
                        if (i === this.bufferedWarnings.length - 1) {
                            this.bufferedWarnings = [];
                        }
                    }
                }
                if (this.bufferedDebugs.length > 0) {
                    for (i = 0; i < this.bufferedDebugs.length; i++) {
                        if (typeof this.bufferedDebugs[i][1] !== 'undefined') {
                            this.debug('[Stored Debug] ' + this.bufferedDebugs[i][0], this.bufferedDebugs[i][1])
                        } else {
                            if (this.bufferedDebugs[i][0]) {
                                this.debug('[Stored Debug] ' + this.bufferedDebugs[i][0])
                            }

                        }
                        if (i === this.bufferedDebugs.length - 1) {
                            this.bufferedDebugs = [];
                        }
                    }
                }
                if (this.bufferedInfos.length > 0) {
                    for (i = 0; i < this.bufferedInfos.length; i++) {
                        if (typeof this.bufferedInfos[i][1] !== 'undefined') {
                            this.info('[Stored Info] ' + this.bufferedInfos[i][0], this.bufferedInfos[i][1])
                        } else {
                            if (this.bufferedInfos[i][0]) {
                                this.info('[Stored Info] ' + this.bufferedInfos[i][0])
                            }

                        }
                        if (i === this.bufferedInfos.length - 1) {
                            this.bufferedInfos = [];
                        }
                    }
                }
                if (this.bufferedTraces.length > 0) {
                    for (i = 0; i < this.bufferedTraces.length; i++) {
                        if (typeof this.bufferedTraces[i][1] !== 'undefined') {
                            this.trace('[Stored Trace] ' + this.bufferedTraces[i][0], this.bufferedTraces[i][1])
                        } else {
                            if (this.bufferedInfos[i][0]) {
                                this.trace('[Stored Trace] ' + this.bufferedTraces[i][0])
                            }

                        }
                        if (i === this.bufferedTraces.length - 1) {
                            this.bufferedTraces = [];
                        }
                    }
                }
            } else {
                this.log = noopLog;
                this.error = noopError;
                this.warn = noopWarn;
                this.debug = noopDebug;
                this.info = noopInfo;
                this.trace = noopTrace;
            }
            //this.log.apply(this, arguments);
            return log;
        },
    }
});
